import { useAuth0 } from '@auth0/auth0-react';
import PreSchoolService from 'Lib/API/PreSchool';
import { InputField, LabelField } from 'components';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { toastr } from 'react-redux-toastr';
import FormBuilder from './FormBuilder';

import Button from 'components/button/Button';
import { formatDateInFormData } from 'utils/formDataHelper';
import './NewQuestionForm.scss';
const NewQuestionForm = ({ formik,selectedTemplate, type = "create",handleCreateAndUpdateSuccess }) => {
  const { getAccessTokenSilently } = useAuth0();

  const [templateName, setTemplateName] = useState(selectedTemplate?.form_name || "");
  const [taskData, setTaskData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getFormLoading, setGetFormLoading] = useState(false);

  const checkUpdateType = () => {
    const valid = selectedTemplate && selectedTemplate?.id && type === "update";
    return Boolean(valid);
  }


const getFormByIdHandler = async () => {
  const isUpdateType = checkUpdateType();
  if(!isUpdateType) return;
  setGetFormLoading(true);
  try {
    const token = await getAccessTokenSilently();
    const response = await PreSchoolService.getTemplateFormByID(
      token,
      selectedTemplate?.id
    );
    if(!response){
      toastr.error('Error', 'Form not found');
      return [];
    }
    setTemplateName(response?.form_name)
    const formTaskData = response?.task_data?.filter(
      (item) => !formik?.values?.requiredFieldsIds?.includes(item?.id)
      );
    const formTaskDataFiltered = formatDateInFormData(formTaskData);
    setTaskData(formTaskDataFiltered)
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(formTaskDataFiltered);
      }, 1000);
    });
  } catch (error) {
    toastr.error("Error", error?.data?.message || "Something went wrong");
  } finally {
    setGetFormLoading(false);
  }
};

const onSetFormHandler = (data) => {
  setTaskData(data?.task_data)
}


const submitForm = async () => {
  const formId = selectedTemplate?.id || "";
  if (!templateName) {
    toastr.info('Validation', 'Please add form name');
    return;
  }

  const requiredFields = formik.values?.requiredFormFields

  const task_data= taskData || [];
  const formData = [
    ...requiredFields,
    ...task_data,
  ]
  setLoading(true);
  const data = {
    form_name: templateName,
    available: true,
    requiredFelids: formik.values?.requiredFelids,
    task_data: formData,
    ...(!formId ? {type: "education"} : {}),
  };
  try {
    const token = await getAccessTokenSilently();
    const response = (type === "update" && formId) ?  await PreSchoolService.updateFormTemplate(token, data,formId) : await PreSchoolService.createForm(token, data);
    toastr.success('Success', `Form ${formId ? 'updated' : 'created'} successfully`);
    if(type === "create") {
      formik.setFieldValue('formId', response?.result?._id);
      formik.setFieldValue("form_name", templateName);
    }
    formik.setFieldValue("form", { task_data: formData });

    handleCreateAndUpdateSuccess()
  } catch (error) {
    toastr.error('Error', error?.data?.message || 'Something went wrong');
  }
  setLoading(false);
};

  return (
    <div className="create-form__wrapper">
    <div className="info_title d-flex justify-content-between align-items-center">
           <div>
             <h2>Form</h2>
           </div>
         </div>
      <div className="form__name">
        <Row>
          <Col className="col-sm-6">
            <InputField
              mandatory
              formik={formik}
              checkValidation={true}
              title="How would you like to call this form?"
              name="form_name"
              value={templateName}
              handleChange={(e) =>
                setTemplateName(e?.target?.value)
              }
              formStyle={{
                maxWidth: '100%',
                height: '54px',
              }}
              style={{ width: '100%', height: '100%', background: '#fff' }}
              disabled={type == "update"}
            />
          </Col>
          <Col className="col-sm-6">
            <LabelField title="Would you like to save as a template?" />
            <div className='py-3'>
              <Button
                onClick={submitForm}
                disabled={loading}
                size="md"
                variant="primary"
              >
                Save Template
                {loading && (
                  <span
                    class="spinner-border spinner-border-sm ml-2"
                    role="status"
                  ></span>
                )}
              </Button>
            </div>
          </Col>
        </Row>
        <Row></Row>
      </div>
      <div className="form__content">
        <FormBuilder formik={formik} getFormByIdHandler={getFormByIdHandler} onSetFormHandler={onSetFormHandler} checkUpdateType={checkUpdateType} />
      </div>
    </div>
  );
};

export default NewQuestionForm;

